import { FormattedMessage, useIntl } from "react-intl";
import { useState } from "react";
import PopoverDisclosure from "../../../../common/core-ui/PopoverDisclosure.tsx";
import { clsx } from "clsx";
import MiscellaneousEllipsis from "../../../../common/icons/MiscellaneousEllipsis.tsx";
import MyAccountDialogSwitcher from "../sidebar/my-account/MyAccountDialogSwitcher.tsx";
import { popoverOffsetY } from "./utils.ts";
import { useHelp } from "../../common/help/useHelp.ts";
import BaseLinkOrButton from "../../../../common/core-ui/BaseLinkOrButton.tsx";
import GrayButtonList from "../sidebar/GrayButtonList.tsx";

export default function ThreeDot() {
  const intl = useIntl();
  const [isAccountDialogOpen, setAccountDialogOpen] = useState(false);
  const helpInfo = useHelp();

  return (
    <>
      <PopoverDisclosure
        yOffset={popoverOffsetY}
        placement="bottom-end"
        renderTrigger={(props) => (
          <button
            {...props}
            aria-label={intl.formatMessage({ defaultMessage: "More Options" })}
            data-tooltip-content={intl.formatMessage({
              defaultMessage: "More Options",
            })}
            className={clsx(
              "vst-icon-button-circle",
              "vst-icon-button-variant-black",
              "vst-icon-button-option-negative-margin"
            )}
          >
            <MiscellaneousEllipsis />
          </button>
        )}
      >
        <div className="vst-popover">
          <GrayButtonList
            showIcons={false}
            className={clsx("vst-popover-section", "vst-popover-link-list")}
          />
          <ul className="vst-popover-section vst-popover-link-list">
            <li>
              <button onClick={() => setAccountDialogOpen(true)}>
                <FormattedMessage defaultMessage="My Account" />
              </button>
            </li>
            {helpInfo.hasGeneralSupport && (
              <li>
                <BaseLinkOrButton href={helpInfo.generalSupportURL}>
                  <FormattedMessage defaultMessage="Support" />
                </BaseLinkOrButton>
              </li>
            )}
          </ul>
        </div>
      </PopoverDisclosure>
      {isAccountDialogOpen && (
        <MyAccountDialogSwitcher
          onRequestClose={() => setAccountDialogOpen(false)}
        />
      )}
    </>
  );
}
